// Requirement deep link: opens the Workspace review on the requirement's document with the requirement selected.
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { useRegionParam } from "@/app/region";
import { cn, linkClass } from "@/lib/cn";
import { docUidOf } from "@/lib/url";

interface RequirementLinkProps {
  reqUid: string;
  region?: string;
  children: ReactNode;
  className?: string;
}

export function RequirementLink({ reqUid, region, children, className }: RequirementLinkProps) {
  const param = useRegionParam(region);
  if (param === null) {
    return <span className={className}>{children}</span>;
  }
  return (
    <Link
      to="/$region/workspace"
      params={{ region: param }}
      search={{ doc: docUidOf(reqUid), req: reqUid }}
      className={cn(linkClass, className)}
    >
      {children}
    </Link>
  );
}
